// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCD-9rm70WG0QgHjht4BJdj0kbw2EsEuN8",
    authDomain: "hqkv2-294da.firebaseapp.com",
    projectId: "hqkv2-294da",
    storageBucket: "hqkv2-294da.appspot.com",
    messagingSenderId: "622512763876",
    appId: "1:622512763876:web:5ef36eaaad10f942c8cdf1",
    measurementId: "G-39239TJ7TV"
  },
  contacts: [
    { name: "1. Bùi Anh Tiến - Phó Đội trưởng - 0913 557 533" },
    { name: "2. Phạm Văn Định - Kiểm hóa viên - 0962 336 566" },
    { name: "3. Bùi Tiến Hậu - Kiểm hóa viên - 0936 883 815" },
    { name: "4. Trương Bình Lộc - Kiểm hóa viên - 0938 337 550" },
    { name: "5. Trần Quốc Hưng - Kiểm hóa viên - 0913 245 821" }
  ],
  qrImage: "/assets/img/qrcode_kv2_.png",
  listGmail: ["tungbi4790@gmail.com", "kiemhoakv2@gmail.com", "phtungduong32@gmail.com"],
  title: "Đăng ký kiểm tra thực tế hàng hóa – Chi cục HQ cửa khẩu cảng HP KV2"
};



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
